import { render, staticRenderFns } from "./ProjectActivitiesDialog.vue?vue&type=template&id=e5280622&"
import script from "./ProjectActivitiesDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectActivitiesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports